export default __webpack_public_path__ + "static/media/tlvc@3x.00d5f596.png";